export class PdfSectionOutputResult
{
    bottomOfOutput = 20; // This should be the same as marginTop
    currentPageNumber = 1;
    hasFooter = false;
    borderColor ='#000000';
    fontSize = null;
}
